export default "__VITE_ASSET__B5BzM$B3__"